import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import { Button, Tooltip, OutlinedInput } from "@mui/material";
import Rating from "@mui/material/Rating";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import images from "../../../global-styles/images";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ButtonBase from "@mui/material/ButtonBase";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import CustomInput from "../../CustomInput";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { appLogger } from "../../../utils";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));

const MobileFeedbackCategory = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "FeedbackSettingsPreview",
      component: "add-product",
      fileName: "FeedbackSettingsPreview.tsx",
      props: props,
    },
  });
  const { productParams } = props;
  const [checked, setChecked] = React.useState([0]);
  const [StdFbscontent, setStdFbscontent] = React.useState<any>("");
  const [selectedCat, setselectedCat] = React.useState<any>("");
  const [PreviewZoom, setPreviewZoom] = React.useState<any>("zoomout");

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const FdSettingsRatingStar = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.ratingLimit || 0
    );
  };
  const FdSettingsrequireEmail = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.requireEmail == true
      ? "(required)"
      : "(optional)";
  };
  const GenSettingsFbcategoryHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categoryHeading || ""
    );
  };
  const FdSettingsrequireCategory = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqCategory == true
      ? "(required)"
      : "(optional)";
  };
  const FdSettingsCategories = () => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length > 0
    ) {
      content = (
        <>
          <Typography sx={{ mt: 1 }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{ mb: 0.2, fontSize: 12 }}
            >
              {` ${GenSettingsFbcategoryHeading()} ${FdSettingsrequireCategory()}`}
            </InputLabel>
            <FormControl fullWidth>
              <Select
                value={selectedCat}
                inputProps={{ "aria-label": "Without label" }}
                onChange={(event) => handleCatChange(event)}
                displayEmpty
              >
                <MenuItem value="" disabled>{`Select a Category ${
                  productParams.productParams.products[0].feedbackAgentSettings
                    ?.feedbackSettings?.reqCategory == true
                    ? "*"
                    : ""
                }`}</MenuItem>
                {productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
                  (val: any, index: any) => (
                    <MenuItem value={val.name}>{val.name}</MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Typography>
        </>
      );
    }
    return content;
  };
  const CatFbStdFeedbacks = (checkName: any) => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length > 0
    ) {
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
        (val: any, index: any) => {
          if (val.feedbacks.length > 0 && val.name == checkName) {
            content = (
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  ml: 0.5,
                  bgcolor: "background.paper",
                }}
              >
                {val.feedbacks.map((value: any) => {
                  const labelId = `checkbox-list-label-${value}`;
                  return (
                    <ListItem
                      key={value}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="comments"
                        ></IconButton>
                      }
                      disablePadding
                    >
                      <Checkbox
                        className="fdstdfeedbackscheck"
                        // onClick={handleToggle(value)}
                        edge="start"
                        checked={checked.includes(value)}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                      <ListItemText
                        className="agent-fb-catelist-text"
                        id={labelId}
                        primary={`${value}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            );
          }
        }
      );
    }
    setStdFbscontent(content);
    // return content
  };

  const GenSettingsFbCommentsHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.generalCommentsHeading || ""
    );
  };
  const GenSettingsFbCommentreqComments = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqComments == true
      ? " (required)"
      : " (optional)";
  };
  const FbTopdialogMsg = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.dialogMsg || ""
    );
  };
  const renderGeneralSettingsMainTitle = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings?.title || ""
    );
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };

  const handleCatChange = (event: any) => {
    setselectedCat(event.target.value);
    productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
      (val: any, index: any) => {
        if (val.name == event.target.value) {
          CatFbStdFeedbacks(event.target.value);
        }
      }
    );
  };
  React.useEffect(() => {
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length == 1
    ) {
      setselectedCat(
        productParams.productParams.products[0].feedbackAgentSettings
          ?.feedbackSettings?.categories[0].name
      );
      CatFbStdFeedbacks(productParams);
    } else {
      setselectedCat("");
      setStdFbscontent("");
    }
  }, [
    productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.categories?.length,
  ]);

  //   const fullSize = () => {
  //     const docElm: any = document.getElementById('myvideo')

  //     if (docElm.requestFullscreen()) {
  //       // exitFullscreen is only available on the Document object.
  //       docElm.exitFullscreen()
  //       setPreviewZoom('zoomout')
  //     } else {
  //       docElm.requestFullscreen()
  //       setPreviewZoom('zoomin')
  //     }

  //     return
  //   }
  const fullscreenchanged = (event: any) => {
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If not, the value
    // of the property is null.
    if (document.fullscreenElement) {
      setPreviewZoom("zoomin");
    } else {
      setPreviewZoom("zoomout");
    }
  };

  const el: any = document.getElementById("fullscreen-div");
  const tt: any = document.getElementById("toggle-fullscreen");

  if (el != null) {
    el.addEventListener("fullscreenchange", fullscreenchanged);
    // or
    el.onfullscreenchange = fullscreenchanged;
  }

  if (tt != null) {
    // When the toggle button is clicked, enter/exit fullscreen

    tt.addEventListener("click", (event: any) => {
      if (document.fullscreenElement) {
        // exitFullscreen is only available on the Document object.
        document.exitFullscreen();
      } else {
        el.requestFullscreen();
      }
    });
  }
  const zoomClick = () => (event: any) => {
    const fullscreendiv: any = document.getElementById("fullscreen-rating");
    if (document.fullscreenElement) {
      setPreviewZoom("zoomout");
      // exitFullscreen is only available on the Document object.
      document.exitFullscreen();
    } else {
      fullscreendiv.requestFullscreen();
      setPreviewZoom("zoomin");
    }
  };
  return (
    <>
      <Typography className="prev-text-titile">
        Feedback Settings: Preview &nbsp;
      </Typography>
      <div
        id="fullscreen-rating"
        className={`genset-fullscreen-div ${PreviewZoom}`}
      >
        <Grid
          className={`mobile-mockup ${PreviewZoom}`}
          container
          sx={{
            background: "#fff",
            mt: 1,
            p: 2,
            border: "1px solid #dbdce0",
            boxShadow:
              "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
          }}
        >
          <Grid className="mobile-header">
            <CloseIcon />
            <Typography className="title-sm">share feedback</Typography>
          </Grid>

          <div className="genset-toggle-fullscreen">
            <Typography id="toggle-fullscreen" onClick={zoomClick()}>
              {PreviewZoom == "zoomout" ? <ZoomInIcon /> : <ZoomOutIcon />}
            </Typography>
          </div>
          <Grid item xs={12} className="preview-content">
            <Typography className="fbtopdialogtitle">
              {FbTopdialogMsg()}
            </Typography>
            <Typography
              className="fbrating"
              sx={{ textAlign: "center", mb: 2, mt: 2 }}
            >
              <Rating
                name="read-only"
                value={FdSettingsRatingStar()}
                readOnly
              />
            </Typography>
            <Grid container rowSpacing={1} className="mobile-footer-btn">
              <Button variant="contained" color="secondary">
                back
              </Button>
              <Button variant="contained" color="primary">
                next
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MobileFeedbackCategory;
